import { Collection } from "@tblabs/truffle";
import { DateTimeProvider } from "../../Services/DateTimeProvider";
import { ChatEntry } from "../Models/ChatEntry";
import { ChatEntryStatus } from "../Models/ChatEntryStatus";
import { ChatUser } from "../Models/ChatUser";
import { IChatConnector } from "../Services/IChatConnector";
import { RawChatEntry } from "../Models/RawChatEntry";


export class Chat
{
	public Users = new Collection<ChatUser>();
	public User = new ChatUser();
	public Messages = new Collection<ChatEntry>();

	constructor(private _connector: IChatConnector, user: ChatUser)
	{
		this.User = user;

		_connector.OnMessage(message =>
		{
			if (message.Id != this.Messages.Last()?.Id)
			{
				this.Messages.Add(message);
			}
		});
	}

	public async AddMessage(message: string): Promise<void>
	{
		const entry = new ChatEntry({
			Author: this.User.Name,
			Message: message,
			Time: DateTimeProvider.Now,
		} as RawChatEntry);

		entry.Status.value = ChatEntryStatus.Sending;

		this.Messages.Add(entry);

		await this._connector.AddOrUpdate(entry);

		entry.Status.value = ChatEntryStatus.Sent;
	}	
	
	public get IsUnread() 
	{ 
		return this.Messages.Last() && this.Messages.Last()?.Author?.value != this.User.Name; 
	}
}
